import React, { lazy } from 'react';
import { GoldButton } from './GoldButton';
import { motion } from 'framer-motion';
interface SpeakerSectionProps {
  onRegisterClick: () => void;
}
export function SpeakerSection({
  onRegisterClick
}: SpeakerSectionProps) {
  return <section className="py-16 md:py-24 bg-brand-blue relative overflow-hidden" data-id="element-158">
      <div className="container mx-auto px-4" data-id="element-159">
        <div className="text-center mb-12 md:mb-16" data-id="element-160">
          <h2 className="font-display text-white uppercase tracking-widest text-sm md:text-base mb-2" data-id="element-161">
            Who is Chris Rassam
          </h2>
          <p className="font-body text-gray-400 italic text-sm" data-id="element-162">
            (And why should you listen?)
          </p>
        </div>

        <div className="flex flex-col md:flex-row items-center gap-12 md:gap-20 max-w-6xl mx-auto" data-id="element-163">
          {/* Left Column: Text */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="flex-1 order-2 md:order-1" data-id="element-164">
            <h3 className="font-display text-white text-3xl md:text-4xl lg:text-5xl font-bold uppercase leading-tight mb-8" data-id="element-165">
              Learn from the{' '}
              <span className="text-brand-gold relative inline-block" data-id="element-166">
                CRE Daily Habit Master
                <div className="absolute -bottom-2 left-0 w-full h-1 bg-brand-gold" data-id="element-167"></div>
              </span>
            </h3>

            <div className="space-y-6 font-body text-white/90 text-base md:text-lg leading-relaxed mb-10" data-id="element-168">
              <p data-id="element-169">
                After a multi-million dollar exit from my FinTech company in
                2018, I went all-in on commercial real estate. No syndications.
                No passive checks. I buy, operate, and reposition my own deals.
              </p>
              <p data-id="element-170">
                I didn't build the <strong data-id="element-171">FAST Profit System</strong> to sell
                courses. I built it because I needed a repeatable process to
                scale my own acquisitions. Every deal example in this Workshop
                came from my <strong data-id="element-172">active pipeline</strong>. Every strategy
                taught is one I've used in the <strong data-id="element-173">last 12 months</strong>.
              </p>
              <p data-id="element-174">
                Today, through my company <strong data-id="element-175">Rassam Capital</strong>, I
                operate across <strong data-id="element-176">four states</strong>, Colorado, Michigan,
                Florida, and Arizona, with active holdings in{' '}
                <strong data-id="element-177">multifamily, self-storage, and hospitality</strong>. His
                current Florida self-storage facility went from 0% to 75%
                occupancy in the last reposition cycle. Next chapter: RV parks
                and mobile home parks, currently in active underwriting. Every
                acquisition targets <strong data-id="element-178">9–10% cap rates</strong> in markets
                most operators have stopped finding.
              </p>
            </div>

            <GoldButton onClick={onRegisterClick} mainText="Secure Ticket Now" subText="(DON'T WAIT!)" className="w-full md:w-auto" data-id="element-179" />
          </motion.div>

          {/* Right Column: Photo — flush right, larger, single overlay label */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="order-1 md:order-2 relative w-full md:w-[55%] md:flex-shrink-0 md:-mr-4 lg:-mr-8" data-id="element-180">
            <div className="relative z-10" data-id="element-181">
              <img src="https://cdn.magicpatterns.com/uploads/jwWWo36Hs5gz9G8FWVR9gh/69f246bc663e5f92fff471ab.png" alt="Chris Rassam" className="w-full h-auto object-contain drop-shadow-2xl" loading="lazy" decoding="async" data-id="element-182" />

              {/* Single overlay label — anchored to his left shoulder, kept well clear of his face/ear */}
              <div className="absolute left-0 md:-left-4 lg:-left-8 top-[28%] md:top-[30%] z-20 max-w-[55%] text-left" style={{
              textShadow: '0 2px 6px rgba(0,0,0,0.95), 0 0 18px rgba(0,0,0,0.85), 0 0 40px rgba(0,0,0,0.7)'
            }} data-id="element-183">
                <img src="https://cdn.magicpatterns.com/uploads/ji7HstGBxecXqS6cQVXteZ/Chris_Rassam.png" alt="Chris Rassam signature" className="block w-48 md:w-64 lg:w-80 h-auto mb-2 -ml-3 md:-ml-4 lg:-ml-5 pl-[7px] pr-[7px]" style={{
                filter: 'drop-shadow(0 2px 6px rgba(0,0,0,0.85)) drop-shadow(0 0 18px rgba(0,0,0,0.75))'
              }} loading="lazy" decoding="async" data-id="element-184" />
                <div className="font-display text-white text-xs md:text-sm uppercase tracking-[0.2em] font-semibold leading-snug" data-id="element-185">
                  <span className="block pl-[3px] pr-[3px]" data-id="element-186">
                    Multi-Millionaire
                  </span>
                  <span className="block pl-[3px] pr-[3px]" data-id="element-187">
                    Real Estate Investor
                  </span>
                </div>
              </div>
            </div>

            {/* Soft background glow */}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[120%] h-[120%] bg-brand-gold/5 rounded-full blur-3xl -z-10" data-id="element-188"></div>
          </motion.div>
        </div>
      </div>
    </section>;
}